import React from 'react'
import Backdrop from '@mui/material/Backdrop'
import { Box } from '@mui/material'
import { useSelector } from 'react-redux'

import FarmLoader from '../FarmLoader'
import { SyncProgressBlock, SyncSteps } from './SyncPanel'
import { useSyncPanelModel } from './useSyncPanelModel'
import { useSyncStatus } from './useSyncStatus'

/**
 * Painel em modo progresso (Decisão 15). Mesmo wrapper e z-index do Loading global
 * (src/components/Loading.tsx): continua bloqueante. `useStatus` é injetável nos testes.
 */
export default function SyncProgressOverlay({ useStatus = useSyncStatus }) {
  const currentSync = useSelector((s) => s.sync.currentSync)
  // Durante o envio a contagem muda em segundos: poll curto só enquanto o overlay existe.
  const { snapshot } = useStatus(currentSync, {
    intervalMs: 3000,
    minGapMs: 1000,
  })
  const model = useSyncPanelModel(snapshot, { tickMs: 1000 })
  const title = model.progress?.title ?? 'Sincronizando...'

  return (
    <div
      style={{
        zIndex: 100000,
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
    >
      <Backdrop
        open
        transitionDuration={0}
        className='farmLoader-backdrop'
        sx={{ backgroundColor: 'rgba(26, 26, 26, 0.45)', px: 2 }}
      >
        <div
          className='farmLoader-card'
          role='dialog'
          aria-modal='true'
          aria-label='Sincronização em andamento'
          style={{ width: '100%', maxWidth: 480 }}
        >
          <FarmLoader label={title} labelColor='#1A1A1A' isGlobalOverlay />
          <Box sx={{ display: 'grid', gap: 2, mt: 2, textAlign: 'left' }}>
            {model.progress && <SyncProgressBlock progress={model.progress} />}
            <SyncSteps steps={model.steps} compact />
          </Box>
        </div>
      </Backdrop>
    </div>
  )
}
